import { Box } from "@mui/material"

const validateData = (data) => {

    const response = []

    if (data.process.length === 0)
        response.push(<Box>Adicione o número do processo</Box>)

    if (response.length === 0)
        return ''

    return (response)
}






export default validateData